// extracted by mini-css-extract-plugin
export default {"shadowCalculatorContainer":"PriceContainer_shadowCalculatorContainer__l-lnU"};